@if (!isSuccess()) {
  <form [formGroup]="areaForm" (ngSubmit)="onSubmit()" class="form-crear-area">
    <div class="form-content">
      <div class="grid-form">
        <!-- Campo Nombre de Referencia -->
        <div class="input-mat">
          <label for="nombreReferencia">Nombre de Referencia *</label>
          <app-input-field-material
            [formControl]="nombreReferencia"
            [errorInput]="
              nombreReferencia.hasError('required')
                ? 'El nombre de referencia es obligatorio'
                : nombreReferencia.hasError('maxlength')
                  ? 'Máximo 100 caracteres'
                  : ''
            "
            placeholder="Ej. Parcela Norte, Sector A1">
          </app-input-field-material>
        </div>

        <!-- Campo Información Extra -->
        <div class="input-mat">
          <label for="informacionExtra">
            Información Extra o Referencia Catastral (opcional)
          </label>
          <app-text-area-material
            [formControl]="informacionExtra"
            [errorInput]="
              informacionExtra.hasError('maxlength')
                ? 'Máximo 500 caracteres'
                : ''
            "
            placeholder="Ej. Contine parcelas ref. cat 46251A01000545 y 46251A01000577">
          </app-text-area-material>
        </div>

        <!-- Selector de Cultivos -->
        <div class="input-mat">
          <label for="cultivos">Cultivos (opcional)</label>
          <app-select-material
            [data]="list_cultivos"
            [error]="''"
            placeholder="Seleccione un tipo de cultivo"
            [formControl]="cultivos">
          </app-select-material>
        </div>
      </div>
    </div>
  </form>
} @else {
  <div class="success-container">
    <span class="material-symbols-rounded">check_circle</span>
    <div class="success-message-area">
      <span class="textos-headline-small">¡Área creada con éxito!</span>
      <span class="textos-body-medium">
        Cada vez que accedas al módulo de Teledetección, verás la zona
        delimitada en el mapa y podrás consultar sus indicadores
        disponibles.</span
      >
    </div>
  </div>
}
